import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import config from "./config";

const LDProvider = async () => {
  const { launchDarklyClientSideId } = config;

  const ldProvider = await asyncWithLDProvider({
    clientSideID: launchDarklyClientSideId,
    context: {
      kind: "user",
      key: "anonymous",
      anonymous: true,
    },
    options: {
      streaming: true,
    },
  });

  return ldProvider;
};

export default LDProvider;
